
export class AddNewFundToRangeCommand {
  constructor(public surveyId: string,
    public fundName: string,
    public fundCode: string,
    public currencyId: number) { }
}
